import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 33,
	viewBox: "0 0 28 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19 9C19 7.25 18 5.625 16.5 4.6875C14.9375 3.8125 13 3.8125 11.5 4.6875C9.9375 5.625 9 7.25 9 9C9 10.8125 9.9375 12.4375 11.5 13.375C13 14.25 14.9375 14.25 16.5 13.375C18 12.4375 19 10.8125 19 9ZM6 9C6 6.1875 7.5 3.5625 10 2.125C12.4375 0.6875 15.5 0.6875 18 2.125C20.4375 3.5625 22 6.1875 22 9C22 11.875 20.4375 14.5 18 15.9375C15.5 17.375 12.4375 17.375 10 15.9375C7.5 14.5 6 11.875 6 9ZM3.0625 30H24.875C24.3125 26.0625 20.9375 23 16.8125 23H11.125C7 23 3.625 26.0625 3.0625 30ZM0 31.1875C0 25 4.9375 20 11.125 20H16.8125C23 20 28 25 28 31.1875C28 32.1875 27.125 33 26.125 33H1.8125C0.8125 33 0 32.1875 0 31.1875Z",
		fill: "#D9D9D9"
	})]
});
const ForwardRef = forwardRef(SvgIconUser);
export { ForwardRef as ReactComponent };
